<template>
  <div>
    <div
      class="section-footer top-footer d-dev"
      v-if="currentRouteName == 'Index'"
    >
      <div class="section-footer-inner">
        <div class="footer-menu-link">
          <div>
            <img class="logo" src="/static/img/logo/logo.png" alt="logo" />
          </div>
          <div>
            <a href="#">หน้าหลัก</a>
            <a href="#">เกี่ยวกับพวกเรา</a>
            <a href="#">คำถามที่พบบ่อย</a>
            <a href="#">ติดต่อพวกเรา</a>
            <a href="#">ข้อกำหนดและเงื่อนไข</a>
            <a href="#">นโยบายความเป็นส่วนตัว</a>
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="section-footer mid-footer d-dev"
      v-if="currentRouteName == 'Index'"
    >
      <div class="section-footer-inner">
        <div class="footer-providers">
          <div class="icon slick-initialized slick-slider">
            <div class="slick-list draggable">
              <swiper v-bind="swiperOptions" class="slick-track">
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-1.png"
                    src="/static/img/landing/Bottom-Icon-1.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-2.png"
                    src="/static/img/landing/Bottom-Icon-2.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-3.png"
                    src="/static/img/landing/Bottom-Icon-3.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-4.png"
                    src="/static/img/landing/Bottom-Icon-4.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-7.png"
                    src="/static/img/landing/Bottom-Icon-7.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-8.png"
                    src="/static/img/landing/Bottom-Icon-8.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-10.png"
                    src="/static/img/landing/Bottom-Icon-10.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-12.png"
                    src="/static/img/landing/Bottom-Icon-12.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-13.png"
                    src="/static/img/landing/Bottom-Icon-13.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-14.png"
                    src="/static/img/landing/Bottom-Icon-14.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-17.png"
                    src="/static/img/landing/Bottom-Icon-17.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-18.png"
                    src="/static/img/landing/Bottom-Icon-18.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-22.png"
                    src="/static/img/landing/Bottom-Icon-22.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-26.png"
                    src="/static/img/landing/Bottom-Icon-26.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-27.png"
                    src="/static/img/landing/Bottom-Icon-27.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-28.png"
                    src="/static/img/landing/Bottom-Icon-28.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-31.png"
                    src="/static/img/landing/Bottom-Icon-31.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-32.png"
                    src="/static/img/landing/Bottom-Icon-32.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-33.png"
                    src="/static/img/landing/Bottom-Icon-33.png"
                  />
                </swiper-slide>
                <swiper-slide class="footer-prov-list slick-slide">
                  <img
                    class="img-responsive lazy"
                    data-src="/static/img/landing/Bottom-Icon-34.png"
                    src="/static/img/landing/Bottom-Icon-34.png"
                  />
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <div class="footer-mid-content">
          <div class="mid-content hide social-media-holder">
            <h5 class="text-uppercase">ได้รับการติดต่อ</h5>
            <div class="social-media">
              <img
                class="img-responsive fb-btn"
                src="/static/img/landing/ico-facebook.png"
              />
              <img
                class="img-responsive insta-btn"
                src="/static/img/landing/ico-ig.png"
              />
            </div>
          </div>
          <div class="vertical-line hide social-media-holder"></div>
          <div class="mid-content">
            <h5 class="text-uppercase">รับรอง</h5>
            <div>
              <img class="img-responsive" src="/static/img/landing/bmm.png" />
              <img
                class="img-responsive"
                src="/static/img/landing/godaddy.png"
              />
              <img
                class="img-responsive"
                src="/static/img/landing/itechlab.png"
              />
              <img class="img-responsive" src="/static/img/landing/TST.png" />
            </div>
          </div>
          <div class="vertical-line"></div>
          <div class="mid-content">
            <h5 class="text-uppercase">วิธีการขำระเงิน</h5>
            <div>
              <img
                class="img-responsive"
                src="/static/img/landing/ico-bank.svg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-copyright">
      <div class="section-footer-inner">
        <div class="left-content">
          © 2023 MAFIA239 All Rights Reserved.
        </div>
        <div class="right-content">
          <a href="#" class="ibslogo home-show">
            <img src="/static/img/landing/logo-ibs.png" />
          </a>
          <img class="d-dev" src="/static/img/landing/logo-gamecare.svg" />
          <img class="d-dev" src="/static/img/landing/logo-age.svg" />
          <img class="d-dev" src="/static/img/landing/logo-beaware.svg" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CashBackForm from "@/components/form/CashBackForm";
import PromotionForm from "@/components/form/PromotionForm";
import WheelForm from "@/components/form/WheelForm";
import AfForm from "@/components/form/AfForm";
import WithdrawForm from "@/components/form/WithdrawForm";
import DepositForm from "@/components/form/DepositForm";
import HistoryForm from "@/components/form/HistoryForm";
import ProfileForm from "@/components/form/ProfileForm";
import MemberCard from "@/components/form/MemberCard";
import { EffectCoverflow, Navigation, Pagination, Autoplay } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import "swiper/swiper-bundle.css";
SwiperCore.use([Navigation, Pagination, Autoplay, EffectCoverflow]);
import "swiper/components/effect-coverflow/effect-coverflow.min.css";

export default {
  name: "Footer",
  data() {
    return {
      isShowNav: true,
      nowPage: this.$route.name,
      swiperOptions: {
        loop: true,
        slidesPerView: 14,
        navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
      },
    };
  },
  components: {
    CashBackForm,
    PromotionForm,
    WheelForm,
    AfForm,
    WithdrawForm,
    DepositForm,
    HistoryForm,
    ProfileForm,
    MemberCard,
    Swiper,
    SwiperSlide,
  },
  computed: {
    ...mapGetters(["getLineId", "appTitle"]),
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    gotoRoute(route) {
      this.$router.push(route);
    },
  },
  watch: {
    $route() {
      this.nowPage = this.$route.name;
      this.isShowNav = true;
      if (
        this.$route.name == "Login" ||
        this.$route.name == "Profile" ||
        this.$route.name == "Signup" ||
        this.$route.name == "Join"
      ) {
        return (this.isShowNav = false);
      }
    },
  },
  mounted() {
    this.nowPage = this.$route.name;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue